<script>
export default {
    props: {
        buttons: {
            type: Object,
            required: true,
        },

        /* 
            definition of the a button item on the buttons array

            {
                is_active: boolean,
                text: string,
                callback: () => any,
                color: string,
            }
        */
    },

    data() {
        return {
            hoveredBtn: null,
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        handleHover(index) {
            this.hoveredBtn = index;
        }
    }
}
</script>

<template>
    <div class="status-wrapper">
        <button v-for="(btn, index) in buttons" :key="index" 
            @click="() => btn.callback()" @mouseover="handleHover(index)" @mouseleave="handleHover(null)"
            :style="{ 
                backgroundColor: btn.is_active || index === hoveredBtn ? btn.color : '#8e8e8e',
                'border-top-left-radius': index == 0 ? '.3em' : null,
                'border-bottom-left-radius': index == 0 ? '.3em' : null,
                'border-top-right-radius': index == buttons.length-1 ? '.3em' : null,
                'border-bottom-right-radius': index == buttons.length-1 ? '.3em' : null,
                'border-left': index != 0 && index != buttons.length ? 'thin solid lightgray' : null,
                'border-right': index != 0 && index != buttons.length ? 'thin solid lightgray' : null,
            }"
        >
            {{ btn.text }}
        </button>
    </div>
</template>

<style lang='scss' scoped>
.status-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    button {
        flex: 1;
        border: 0;
        outline: 0;
        color: white;
        padding: .25em;
        background-color: #8e8e8e;
        transition: background-color 150ms;

        text-wrap: nowrap;
        font-size: .75vw;
    }
}
</style>